import React from 'react';

import { useIcon } from '../';

import type { IButtonProps } from './Button.types';
import { StyledButton } from './Button.styles';

export const Button = ({
  variant = 'primary',
  disabled = false,
  fullWidth = true,
  startIcon,
  endIcon,
  children,
  ...rest
}: IButtonProps) => {
  const fetchedStartIcon = useIcon(startIcon);
  const fetchedEndIcon = useIcon(endIcon);

  return (
    <StyledButton variant={variant} disabled={disabled} fullWidth={fullWidth} {...rest}>
      {startIcon && fetchedStartIcon}

      {children}

      {endIcon && fetchedEndIcon}
    </StyledButton>
  );
};
